
import { Card, CardActionArea, CardContent, CardMedia, Grid, styled,Typography } from '@mui/material';
import dayjs from 'dayjs';
import Localization from 'l18n/l18n';
import * as React from 'react';
import fileImage from '../assets/images/file.jpg';


const AttachedFilesList = ({ files }) => {


    const StyledCard = styled(Card)({
        maxWidth: 300,
        minWidth: 142,
        border: '2px solid #E3E3E3',
        borderRadius: '1rem'
    });
    return (
        <Grid item xs={12} container gap={2} py={1}>

            {files.map((item, key) => {
            const { document_name, create_datetime, signed_url } =  item;
            const imagePath =   fileImage  ;
            const recordPath = signed_url;
            return   (
             
             <Grid item xs={12} key={key} md={6} lg={2}>
             <a href={recordPath} rel="noreferrer noopener" target="_blank" style={{textDecoration: 'none',color:'inherit'}}>
                <StyledCard key={key}>
                    <CardActionArea>
                        <CardMedia
                            component="img"
                            sx={{ background: '#E3E3E3', height: '6rem' }}
                            image={imagePath}
                            alt="green iguana"
                            />
                        <CardContent sx={{ px: '4px' }}>
                            <Typography gutterBottom variant="subtitle2" component="div">
                                <b>
                                   {document_name || '' }
                                </b>
                            </Typography>
                            <Typography variant="caption" display={'flex'} color="text.secondary">
                                {Localization.translate['date']} : {dayjs(create_datetime).format('mm/DD/YYYY')}
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                </StyledCard>
             </a>
            </Grid>);
                }
            )}

        </Grid>
            
            );
};

export default AttachedFilesList;